import { refreshLiveChat } from '~/src/utils/hubspot'

export default defineNuxtRouteMiddleware(() => {
  if (import.meta.server) return
  refreshLiveChat()
})
